var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orkImgGrid"},[_c('div',{staticClass:"orkImgGrid--title"},[_vm._v(_vm._s(_vm.data.name))]),_c('div',{staticClass:"orkImgGrid--reference"},[_vm._v(_vm._s(_vm.data.reference))]),_c('SfImage',{staticClass:"orkImgGrid--image",attrs:{"alt":_vm.data.name?_vm.data.name:'',"src":_vm.data.img,"height":"auto","width":"90"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }